// "Open in <broker>" links for a stock page: the member's broker (chosen in Settings) opens the
// same stock there. Ids come from markets/nse/broker-ids.json (built by scripts/broker-ids.ts).
// MoneyHQ only opens the page; it never sends orders.
import ids from './markets/nse/broker-ids.json';
import { NSE_NAMES } from './markets/nse';

export type BrokerId = 'zerodha' | 'groww' | 'upstox' | 'angelone' | 'tradingview';

export const BROKERS: { id: BrokerId; name: string; app: string }[] = [
  { id: 'zerodha', name: 'Zerodha', app: 'Kite' },
  { id: 'groww', name: 'Groww', app: 'Groww' },
  { id: 'upstox', name: 'Upstox', app: 'Upstox' },
  { id: 'angelone', name: 'Angel One', app: 'Angel One' },
  { id: 'tradingview', name: 'TradingView', app: 'TradingView' },
];

const IDS = ids as Record<string, { k?: number; g?: string; i?: string; a?: string }>;

/** "Tata Consultancy Services Ltd." → tata-consultancy-services-ltd (slug candidates; any slug works for Upstox). */
export const nameSlug = (name: string) =>
  name.toLowerCase().replace(/&/g, ' and ').replace(/\./g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

/** The stock's page at that broker, or null when we don't know its id there. */
export function brokerLink(broker: BrokerId, symbol: string): string | null {
  const id = IDS[symbol];
  switch (broker) {
    case 'zerodha':
      return id?.k ? `https://kite.zerodha.com/chart/web/tvc/NSE/${encodeURIComponent(symbol)}/${id.k}`
        : `https://zerodha.com/markets/stocks/NSE/${encodeURIComponent(symbol)}/`;
    case 'groww':
      return id?.g ? `https://groww.in/stocks/${id.g}` : null;
    case 'upstox':
      // Any slug works: Upstox redirects to its own from the ISIN.
      return id?.i ? `https://upstox.com/stocks/${nameSlug(NSE_NAMES[symbol] ?? symbol)}-share-price/${id.i}/` : null;
    case 'angelone':
      return id?.a ? `https://www.angelone.in/stocks/${id.a}` : null;
    case 'tradingview':
      return `https://www.tradingview.com/chart/?symbol=${encodeURIComponent(`NSE:${symbol.replace(/[&-]/g, '_')}`)}`;
  }
}
